import styled from 'styled-components/macro'

const StyledButton = styled.button`
  background-color: ${({theme}) => theme.color};
  width: ${({open}) => open ? '96px' : '48px'};
  height: 48px;
  border-radius: 28px;
  margin:${({margin}) => margin ? margin : '8px'};
  cursor:pointer;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  padding: 0;
  outline: none;
  border: none;
`

export default StyledButton;